import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { View, Text, Whitespace } from '../common';
import { buildPhotoPath, buildAvatarPath } from '../../helpers/photoutils';
import moment from 'moment';
import { observable, toJS } from 'mobx';
import Button from '../common/FormComponents/Button';
import { TextArea } from '../addListing/Description';
import { Separator } from '../Separator';
import Modal from '../Modal';
import { Query } from 'react-apollo';
import ApproveReservation from './ApproveReservation';
import { getp } from '../../helpers/getProp';
import { sendMessageAction } from '../../actions/message/sendMessageAction';
import { getAvailabilityQ } from './chatQl';
import history from '../../core/history';
import { trackBookFromInbox } from '../../core/analytics';
import { query } from '../../core/createApolloClient/createApolloClient.client';
import userProfileQ from './userProfileQ';

const navBoxStyle = `f-1 f-cc f-rows p-s b-0 br-1 b-coolGrayLightest`;

@inject('userStore')
@observer
export default class Inbox extends Component {
  @observable modalOpen = false;

  goTo = async (actionType, item) => {
    const { inboxStore } = this.props;
    await inboxStore.loadItem(item);
    if (actionType !== 'exchange') {
      inboxStore.setFocused(item.threadId, item, false);
    } else {
      inboxStore.setFocused(item.threadId, item, true);
    }
    console.log('inboxStore.focused', inboxStore.focused);
  };

  refresh = () => {
    this.props.inboxStore.updateSummary();
  };

  startApproval = () => {
    this.modalOpen = true;
  };

  endApproval = success => {
    console.log('Approval success', success);
    if (success) {
      this.props.inboxStore.setFocused(null);
      this.refresh();
    }
    this.modalOpen = false;
  };

  render() {
    const { inboxStore, userStore } = this.props;

    console.log('inboxStore', inboxStore, userStore);

    return (
      <div
        className="g g-tc-a1 f-1 o-hidden"
        style={{
          maxHeight: 'calc(100vh - 120px)',
          height: 'calc(100vh - 120px)',
        }}
      >
        <div className="left b-0 br-1 b-coolGrayLightest">
          <div className="h-65 f f-columns mb-s b-0 bb-1 b-coolGrayLightest">
            <div className={navBoxStyle}>
              <div className="f f-columns f-start-center h-20">
                <i className="fal fa-exchange grayDark fa-lg" />
                <View if={inboxStore.exchangesUnreadCount}>
                  <div className="bg-secondary w-20 h-20 brad-mx ml-m f-cc">
                    <Text white>{inboxStore.exchangesUnreadCount}</Text>
                  </div>
                </View>
              </div>
              <Text class="t-m pt-sxx ">exchanges</Text>
            </div>
            <div className={navBoxStyle}>
              <div className="f f-columns f-start-center h-20">
                <i className="fal fa-calendar grayDark fa-lg" />
                <View if={inboxStore.pendingUnreadCount}>
                  <div className="bg-secondary w-20 h-20 brad-mx ml-m f-cc">
                    <Text white>{inboxStore.pendingUnreadCount}</Text>
                  </div>
                </View>
              </div>
              <Text class="t-m pt-sxx ">pending</Text>
            </div>
            <div className={navBoxStyle}>
              <div className="f f-columns f-start-center h-20">
                <i className="fal fa-question-circle grayDark fa-lg" />
                <View if={inboxStore.inquiriesUnreadCount}>
                  <div className="bg-secondary w-20 h-20 brad-mx ml-m f-cc">
                    <Text white>{inboxStore.inquiriesUnreadCount}</Text>
                  </div>
                </View>
              </div>
              <Text class="t-m pt-sxx ">inquiries</Text>
            </div>
            <div className={navBoxStyle}>
              <div className="f f-columns f-start-center h-20">
                <i className="fal fa-check grayDark fa-lg" />
                <View if={inboxStore.approvedUnreadCount}>
                  <div className="bg-secondary w-20 h-20 brad-mx ml-m f-cc">
                    <Text white>{inboxStore.approvedUnreadCount}</Text>
                  </div>
                </View>
              </div>
              <Text class="t-m pt-sxx ">approved</Text>
            </div>
            <div className={navBoxStyle}>
              <div className="f f-columns f-start-center h-20">
                <i className="fal fa-clock grayDark fa-lg" />
                <View if={inboxStore.completedUnreadCount}>
                  <div className="bg-secondary w-20 h-20 brad-mx ml-m f-cc">
                    <Text white>{inboxStore.completedUnreadCount}</Text>
                  </div>
                </View>
              </div>
              <Text class="t-m pt-sxx ">completed</Text>
            </div>
          </div>

          <div
            className="o-x-auto f-1 o-y-hidden"
            style={{ maxHeight: 'calc(100vh - 200px)' }}
          >
            <Section
              title="EXCHANGES"
              data={this.props.inboxStore.exchanges}
              renderItem={(item, idx) => {
                return (
                  <View
                    onClick={() => this.goTo('exchange', item)}
                    key={item.threadId + item.group}
                  >
                    <InboxItem item={item} idx={idx} isExchange />
                  </View>
                );
              }}
            />
            <Section
              title="PENDING"
              data={this.props.inboxStore.pending}
              renderItem={(item, idx) => {
                return (
                  <View
                    onClick={() => this.goTo('pending', item)}
                    key={item.threadId + item.group}
                  >
                    <InboxItem item={item} idx={idx} />
                  </View>
                );
              }}
            />
            <Section
              title="INQUIRIES"
              data={this.props.inboxStore.inquiries}
              renderItem={(item, idx) => {
                return (
                  <View
                    onClick={() => this.goTo('pending', item)}
                    key={item.threadId + item.group}
                  >
                    <InboxItem item={item} idx={idx} />
                  </View>
                );
              }}
            />
            <Section
              title="APPROVED"
              data={this.props.inboxStore.approved}
              renderItem={(item, idx) => {
                return (
                  <View
                    onClick={() => this.goTo('pending', item)}
                    key={item.threadId + item.group}
                  >
                    <InboxItem item={item} idx={idx} />
                  </View>
                );
              }}
            />
            <Section
              title="COMPLETED"
              data={this.props.inboxStore.completed}
              renderItem={(item, idx) => {
                return (
                  <View
                    onClick={() => this.goTo('pending', item)}
                    key={item.threadId + item.group}
                  >
                    <InboxItem item={item} idx={idx} />
                  </View>
                );
              }}
            />
          </div>
        </div>
        {!inboxStore.focused && <div className="right" />}
        {inboxStore.focused && (
          <InboxDetails
            focused={inboxStore.focused}
            userId={this.props.userStore.id}
            refresh={this.refresh}
            startApproval={this.startApproval}
          />
        )}
        <Modal isOpen={this.modalOpen} maxWidth={800}>
          <Query
            query={getAvailabilityQ}
            variables={{
              id: getp(inboxStore, 'focused.item.reservationId'),
            }}
          >
            {({ loading, error, data }) => {
              console.log(
                'GET GET AVAIL',
                loading,
                JSON.stringify(data),
                error,
              );
              return (
                (error && <Text>Whoops</Text>) || (
                  <ApproveReservation
                    loading={loading}
                    close={this.endApproval}
                    data={
                      !loading &&
                      getp(
                        data,
                        'ReservationAvailabilityRange.blockedDates',
                        [],
                      )
                    }
                    messages={
                      !loading &&
                      JSON.parse(
                        getp(
                          data,
                          'ReservationAvailabilityRange.messages',
                          '{}',
                        ),
                      )
                    }
                    reservation={!loading && inboxStore.focused.item}
                  />
                )
              );
            }}
          </Query>
        </Modal>
      </div>
    );
  }
}

@observer
class InboxDetails extends Component {
  renderPending = () => {
    if (this.props.focused.item.isHost) {
      return (
        <View>
          <View className="f f-columns-reverse f-start-center mx-mxx">
            <Button secondary onClick={this.approve} className="w-200">
              Approve
            </Button>
            <Button muted onClick={this.deny} mx={3}>
              Deny
            </Button>
          </View>
        </View>
      );
    }
    return null;
  };

  approve = async () => {
    const { startApproval } = this.props;
    startApproval();
  };

  deny = async () => {
    const { refresh } = this.props;
    const isSuccess = await this.props.focused.item.deny();
    if (isSuccess) {
      refresh();
    }
  };

  startReservation = () => {
    trackBookFromInbox(
      this.props.focused.item.category,
      this.props.focused.item.listId,
    );
    history.push('/details/' + this.props.focused.item.listId);
  };

  renderApproved = () => {
    return null;
  };
  renderIncomplete = () => {
    return null;
  };
  renderComplete = () => {
    return null;
  };
  renderInquiry = () => {
    return this.props.focused.item.isHost ? null : (
      <View>
        <View className="f-columns-reverse f-start-center mx-mxx">
          <Button secondary action onClick={this.startReservation}>
            Review and Start Request
          </Button>
        </View>
      </View>
    );
  };

  goToOwnerProfile = async () => {
    const userProfileRes = await query(userProfileQ, {
      userId: this.props.focused.item.otherUserId,
    });
    history.push(
      '/users/show/' + getp(userProfileRes, 'data.getProfile.0.profileId'),
    );
  };

  renderActionBlock = () => {
    let block;
    switch (this.props.focused.item.reservationState) {
      case 'pending':
        return this.renderPending();
      case 'approved':
        return this.renderApproved();
      case 'expired':
        return this.renderIncomplete('expired');
      case 'cancelled':
        return this.renderIncomplete('cancelled');
      case 'completed':
        return this.renderComplete();
      default:
        return this.renderInquiry();
    }
  };

  renderFullHeader() {
    const { focused } = this.props;
    const item = focused.item;

    return (
      <View>
        <View className="f f-columns m-mxx">
          <View className="f f-cc f-rows pointer">
            <View
              className="h-70 w-70 b-1 b-primaryDark brad-full z-10 o-hidden bg-white"
              onClick={this.goToOwnerProfile}
            >
              <img
                src={buildAvatarPath(item.otherPicture)}
                className="h-70 w-70"
              />
            </View>
            <Text onClick={this.goToOwnerProfile}>{item.otherDisplayName}</Text>
          </View>
          <View className="f-1 f f-start-stretch ml-m f-rows">
            <View className="f f-columns f-between-center mb-s">
              <Text class="t-h6 primary-2">{item && item.title}</Text>
              <Text class="t-h6 ">{item && item.priceInfo}</Text>
            </View>
            <View className="f f-rows">
              {item.reservationId > 0 && (
                <View className="f-columns f f-between-end">
                  <View className="f f-columns f-start-end mb-s">
                    <View className="">
                      <Text class="t-m grayDark">{item.pickupDayReadable}</Text>
                      <View if={item.pickupTimeReadable}>
                        <Text class="t-m grayDark">
                          {item.pickupTimeReadable}
                        </Text>
                      </View>
                    </View>
                    <View className="mx-m grayDark">
                      <i className="fal fa-chevron-right coolGray" />
                    </View>
                    <View className=" grayDark">
                      <Text class="t-m grayDark">{item.returnDayReadable}</Text>
                      <View if={item.returnTimeReadable}>
                        <Text class="t-m grayDark">
                          {item.returnTimeReadable}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <Text class="t-m">
                    {['approved', 'completed'].indexOf(
                      this.props.focused.item.reservationState,
                    ) >= 0
                      ? this.props.focused.item.pickupAddressStr
                      : this.props.focused.item.city +
                        ', ' +
                        this.props.focused.item.state}
                  </Text>
                </View>
              )}
              <div>{this.renderActionBlock()}</div>
            </View>
          </View>
        </View>
        <Separator />
      </View>
    );
  }

  render() {
    const { focused } = this.props;
    const { isExchange, viewChat } = focused;
    return (
      <div className="f f-rows relative">
        {this.renderFullHeader()}
        <View className="f f-1 f-rows">
          <div className="f f-1 f-rows">
            <ChatComponent thread={focused.item} userId={this.props.userId} />
          </div>
        </View>
        <View if={isExchange && !viewChat} className="absolute-0 f f-cc">
          <div className="absolute-0 bg-grayDark o-20" />

          <div className="p-l brad-md bg-white z-22 f-rows f-cc">
            <Text large>
              {!focused.item.itemDone
                ? 'Open in the app to complete the exchange.'
                : 'Nothing left do here. '}
            </Text>
            <Whitespace medium />
            <Button primary action onClick={() => focused.seeChat()}>
              Got it
            </Button>
          </div>
        </View>
      </div>
    );
  }
}

@observer
class ChatComponent extends Component {
  @observable refreshId = 0;
  @observable threadId = 0;

  messageStyles = {
    mine: {
      outerBox: 'f f-self-flex-end f-columns-reverse',
      box: baseStyles.box + ' bg-primaryHighlight w-max-360',
    },
    theirs: {
      outerBox: 'f f-self-flex-start f-columns',
      box: baseStyles.box + ' bg-offWhite w-max-360',
    },
  };

  componentWillUnmount() {
    this.clearInterval(this.props.thread);
  }

  clearInterval = thread => {
    if (this.refreshId) {
      clearInterval(this.refreshId);
      this.refreshId = 0;
    }
    if (thread) {
      thread.stopMessagePolling();
    }
  };

  startInterval = thread => {
    thread.startMessagePolling();
    // setTimeout(() => {
    //   //This janky thing is here to force a re-render after messages are retrieved
    //   this.refreshId = setInterval(() => this.setState({ hi: true }), 6000);
    // }, 500);
    setTimeout(() => {
      this.scrollToBottom();
    }, 1);
  };

  componentDidMount() {
    this.scrollToBottom();
    this.resetInterval(null, this.props.thread);
  }

  componentWillReceiveProps(nextProps) {
    const { threadId } = nextProps.thread;
    console.log('CWRP - Inbox - threadId', threadId, this.threadId);
    if (threadId && threadId !== this.threadId) {
      this.resetInterval(this.props.thread, nextProps.thread);
    }
  }

  resetInterval(oldThread, newThread) {
    this.threadId = newThread.threadId;
    this.clearInterval(oldThread);
    this.startInterval(newThread);
  }

  getMessageStyle(message) {
    if (message.sentBy === this.props.userId) {
      return this.messageStyles.mine;
    } else {
      return this.messageStyles.theirs;
    }
  }

  getMessagePhoto = message => {
    if (message.sentBy === this.props.userId) {
      return this.props.thread.myPicture;
    } else {
      return this.props.thread.otherPicture;
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      message: '',
    };
  }

  scrollToBottom = () => {
    this.chatsBox.scrollTop = this.chatsBox.scrollHeight;
  };

  // @action
  sendMessage = async () => {
    await this.props.thread.sendMessage();
    this.scrollToBottom();
  };

  changeText = e => {
    this.props.thread.onChangeMessageText(e.target.value);
  };

  buildMessageJSX = (item, index) => {
    const message = item;
    if (message && message.type === 'day-separator') {
      return (
        <View className="f-columns f-cc my-s">
          <View className="bg-primaryDark p-sxx brad-full">
            <Text mx={3} white>
              {item.content}
            </Text>
          </View>
        </View>
      );
    } else if (message && message.content) {
      const styles = this.getMessageStyle(message);
      return (
        <View className={styles.outerBox}>
          <View key={message.id} className={styles.box}>
            <Text noclip>{message.content}</Text>
            <Text t-sx coolGray textAlign="right">
              {message.displayTime}
            </Text>
          </View>
        </View>
      );
    } else {
      return (
        <View className="f f-columns f-sc my-s">
          <View className="f-1 bb-1 t-h1 b-coolGrayLightest" />
          <Text class="mx-sx">{item.type}</Text>
          <View className="f-1 bb-1 t-h1 b-coolGrayLightest" />
        </View>
      );
    }
  };

  render() {
    console.log('re-rendering ChatComponent', this.props.userId);
    const threadItemsOrdered = getp(
      this.props.thread,
      'threadItemsOrdered',
      [],
    );
    return (
      <div className="f-1 relative">
        <div className="f f-rows f-1 absolute top-0 left-0 right-0 bottom-0">
          <div className="w-520 f f-rows f-1 f-self-center h-99p">
            <div
              className="f f-1 o-y-auto o-x-hidden f-rows p-mx"
              ref={e => (this.chatsBox = e)}
            >
              <View
                className="f-columns f-cc my-s"
                if={this.props.thread.hasMoreItems}
              >
                <View
                  className="p-sxx brad-full pointer"
                  onClick={this.props.thread.getOlderThreadItems}
                >
                  <Text px={3} clickable link action>
                    see more
                  </Text>
                </View>
              </View>
              {threadItemsOrdered &&
                threadItemsOrdered.map(this.buildMessageJSX)}
            </div>
            <View className="f f-columns f-self-stretch">
              {
                // <Textarea
                //   rowSpan={2}
                //   bordered
                //   value={this.props.thread.currentMessage}
                //   onChangeText={this.changeText}
                //   placeholder="Type new message..."
                //   className="f-1 br-0 bb-0 bl-0 b-coolGrayLighter mt-sxx pt-mx"
                // />
              }
              <TextArea
                onChange={this.changeText}
                value={this.props.thread.currentMessage}
                placeholder="New message..."
              />

              <View className="f f-self-stretch f-cc b-coolGrayLighter px-m mt-sxx">
                <Button secondary onClick={this.sendMessage}>
                  <i className="fas fa-fighter-jet grayDarkMedium white" />
                </Button>
              </View>
            </View>
          </div>
        </div>
      </div>
    );
  }
}

const baseStyles = {
  box: 'p-s brad-mx mb-m sh-default w-max-420',
};

@observer
class InboxItem extends Component {
  render() {
    const { item, idx, isExchange } = this.props;
    const bgColor = item.itemDone ? 'bg-offWhite' : '';
    return (
      <View
        className={`px-mxx py-s ${
          idx === 0 ? 'bt-1' : ''
        } b-0 bb-1 b-coolGrayLightest f f-columns f-sc ${bgColor} pointer`}
      >
        <View className={`w-14 h-40 f-cc`}>
          <View className={`w-8 h-8 bg-secondary brad-mx`} if={item.isUnread} />
        </View>
        <View className="w-40 mx-m">
          <img
            src={buildPhotoPath('small', item.coverPhotoName)}
            className="w-40 h-40 brad-mxx"
          />
        </View>
        {(isExchange && (
          <View className={`f-1 f f-rows f-start-stretch `}>
            <View className="f f-columns f-between-center">
              <View className="f-1">
                <Text class="grayDarkest">{item.title}</Text>
                <Text class="grayMedium t-s">{item.otherDisplayName}</Text>
              </View>
              <View if={!item.exchangeCompleted}>
                <View className="ml-m ">
                  <Text bold primary>
                    {item.exchangeStage}
                  </Text>
                </View>
              </View>
            </View>
            <Whitespace smaller2 />
            <View className="f f-columns f-start-center">
              <Text class={`${item.pickupCompleted ? '' : 'bold'} mr-s`}>
                {moment.utc(item.pickupDate).calendar()}
              </Text>
              -
              <Text
                class={`${
                  item.pickupCompleted && !item.returnCompleted ? 'bold' : ''
                } ml-s`}
              >
                {moment.utc(item.returnDate).calendar()}
              </Text>
            </View>
          </View>
        )) || (
          <View className="f-1 f f-columns">
            <View className="f-1">
              <Text class={`${!item.isUnread ? 'grayDarkest' : 'bold'}`}>
                {item.title}
              </Text>
              <Text class={`grayMedium t-s`}>{item.otherDisplayName}</Text>
            </View>
            <Text class={`w-75 ${!item.isUnread ? 'grayDarkest' : 'bold'}`}>
              {item.timespan}
            </Text>
          </View>
        )}
      </View>
    );
  }
}

@observer
class Section extends Component {
  render() {
    const { title, data, renderItem } = this.props;
    return (
      <View>
        <View className="b-0 bb-1 bt-1 b-coolGrayLightest py-m px-mxx ">
          <Text class="primaryDark bold pn">{title}</Text>
        </View>
        <View>{data.map((d, i) => renderItem(d, i))}</View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/Inbox/Inbox.js